export const Role = {
  ROLE_ADMINISTRATOR: "Administrador",
  ROLE_SUPERVISOR: "Supervisor",
  ROLE_MANAGER: "Gerênte",
  ROLE_JUNIOR_BROKER: "Corretor Júnior",
  ROLE_INTERMEDIATE_BROKER: "Corretor Pleno",
  ROLE_EXTERNAL_BROKER: "Corretor Externo",
  ROLE_SUPPORT: "Suporte"
};